import { useMutation } from 'react-query'
import { resyncSubscriptionProvisioning } from './api'

export function useResyncSubscriptionProvisioning() {
  return useMutation(resyncSubscriptionProvisioning)
}
